import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { ProductCategoryFormDialog } from "../product-category-form-dialog";

import { Button } from "@mui/material";

export const AddProductCategoryFormDialog = ({ defaultValues, onClose, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({
    name,
    parentId,
    type,
    status,
    accountingActionChartOfAccounts,
  }) => {
    try {
      await apiClient.post("product-categories", {
        name,
        parentId,
        type,
        status,
        accountingActionChartOfAccounts,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan kategori produk"));

      throw error;
    }
  };

  return (
    <ProductCategoryFormDialog
      isOpen
      onClose={onClose}
      dialogTitle="Tambah Kategori Produk"
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddProductCategoryFormDialog.propTypes = {
  defaultValues: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
